import React, { useCallback, useEffect, useState } from 'react';
import WaAdminShell from '../../components/admin/whatsapp/WaAdminShell';
import { createWaAgent, deleteWaAgent, fetchWaAgents, patchWaAgent } from '../../utils/adminWhatsapp';

export default function WhatsAppAgents() {
  const [agents, setAgents] = useState([]);
  const [phone, setPhone] = useState('');
  const [name, setName] = useState('');
  const [msg, setMsg] = useState('');

  const load = useCallback(async () => {
    try {
      const data = await fetchWaAgents();
      setAgents(data.agents || []);
    } catch {
      setAgents([]);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const add = async (e) => {
    e.preventDefault();
    setMsg('');
    try {
      await createWaAgent({ phone, agent_name: name, role: 'tester' });
      setPhone('');
      setName('');
      setMsg('Added');
      load();
    } catch (err) {
      setMsg(err.response?.data?.detail || 'Failed');
    }
  };

  return (
    <WaAdminShell title="Sandbox numbers" subtitle="Test WhatsApp flow without live charges">
      <form onSubmit={add} className="flex flex-wrap gap-2 mb-6 bg-white border rounded-xl p-4">
        <input className="border rounded-lg p-2 text-sm" placeholder="Phone +91…" value={phone} onChange={(e) => setPhone(e.target.value)} required />
        <input className="border rounded-lg p-2 text-sm" placeholder="Label" value={name} onChange={(e) => setName(e.target.value)} />
        <button type="submit" className="bg-[#659A9B] text-white px-4 py-2 rounded-lg text-sm">Add</button>
        {msg && <span className="text-sm text-gray-600 self-center">{msg}</span>}
      </form>
      <div className="bg-white border rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50">
            <tr>
              <th className="p-3 text-left">Phone</th>
              <th className="p-3 text-left">Name</th>
              <th className="p-3">Active</th>
              <th className="p-3" />
            </tr>
          </thead>
          <tbody>
            {agents.map((a) => (
              <tr key={a.id} className="border-t">
                <td className="p-3 font-mono text-xs">{a.phone}</td>
                <td className="p-3">{a.agent_name}</td>
                <td className="p-3 text-center">
                  <input
                    type="checkbox"
                    checked={a.is_active !== false}
                    onChange={(e) => patchWaAgent(a.id, e.target.checked).then(load)}
                  />
                </td>
                <td className="p-3 text-right">
                  <button
                    type="button"
                    className="text-red-600 text-xs"
                    onClick={() => {
                      if (window.confirm('Remove?')) deleteWaAgent(a.id).then(load);
                    }}
                  >
                    Remove
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </WaAdminShell>
  );
}
